import React from 'react'
import _ from 'lodash'

import {Input} from 'forms'

import IntlPhoneNumbers from './.international-phone-codes.json'

function filtermap(array, f) {
   return _.reduce(
      array,
      function(acc, el, k) {
         let res = f(el, k)

         if (undefined !== res && null !== res) {
            acc.push(res)
         }

         return acc
      },
      [],
   )
}

const phoneNumbers = _.map(IntlPhoneNumbers, function(codes, country) {
   return {
      country,
      sanitizedcodes: _.map(codes.split(/ and /), code =>
         code.replace(/^([0-9]+)$/, '+$1').replace(/-/, ''),
      ),
      codes: _.map(codes.split(/ and /), code => code.replace(/^([0-9]+)$/, '+$1'))
   }
})

const filterNumberPrefix = function(number, code) {
   if (!code) {
      return false
   }

   if (number === code) {
      return true
   }

   if (number.length >= code.length) {
      return number.slice(0, code.length) === code
   } else {
      return number === code.slice(0, number.length)
   }
}

const sanitizeNumber = function(number) {
   if (!number) {
      return null
   }

   return '+' + number.replace(/^(00|\+)/, '').replace(/[^0-9]*/g, '')
}

const findCountriesByNumber = function(number) {
   let result = filtermap(phoneNumbers, function({sanitizedcodes, codes, ...rest}) {
      let matches = filtermap(
         _.zip(sanitizedcodes, codes),
         ([sanitized, code]) =>
            (filterNumberPrefix(number, sanitized) ? [sanitized, code] : undefined),
      )

      return 0 < matches.length
         ? _.assign(rest, {sanitizedcode: matches[0][0], code: matches[0][1]})
         : null
   })

   // reverse sort by returning the length as a negative value
   // this ensures the longest common prefix will be at the head of `result`
   return _.sortBy(result, ({code}) => -1 * code.length)
}

export class PhoneInput extends React.Component {
   static get contextTypes() {
      return {
         input:       React.PropTypes.object,
         submitState: React.PropTypes.any,
         patch:       React.PropTypes.object
      }
   }

   static get propTypes() {
      return {
         param: React.PropTypes.string.isRequired
      }
   }

   static formatNumber(number, def) {
      if (!def) {
         return number
      }

      // replace the prefix with a nicely formated prefix
      return number.replace(new RegExp('^\\' + def.sanitizedcode + '\\s*'), def.code + ' ')
   }

   // takes second argument def which contains format props
   static validateNumber(num) {
      // mom always said no input is good input
      if (!num) {
         return true
      }

      if (15 < num.length) {
         return {error: 'Phone numbers can not exceed 15 digits in length'}
      }

      if (!num.match(/^\+/)) {
         return {error: 'Phone numbers must start with a +', state: 'warn'}
      }

      if (num.match(/[^0-9() +-]/)) {
         return {
            error: 'Phone numbers may only contain numbers, (, ), - and spaces',
            state: 'warn'
         }
      }

      return true
   }

   render() {
      let {param} = this.props,
         number = _.get(this.context.patch, param) || _.get(this.context.input, param),
         countries = findCountriesByNumber(number),
         country,
         flag

      // if we have a number and length, with + prefix, of number > 3
      if (number && 3 <= number.length && countries && 1 <= countries.length) {
         flag = countries[0].country
         country = countries[0].country
      }

      return (
         <Input
            param={param}
            label="Phone Number"
            type="tel"
            transform={[sanitizeNumber]}
            format={num => PhoneInput.formatNumber(num, countries[0])}
            validate={num => PhoneInput.validateNumber(num, countries[0])}
            placeholder="+47 79 13 ..."
            suffix={country ? <img alt={country} src={`/public/flags/${flag}.png`} /> : null}
         />
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/user/account/PhoneInput.jsx